import React from "react";
import Banner from "./../../component/Banner";
import Bannerimg from "./../../images/about/about2.webp";
import image2 from "./../../images/about/retail4.webp";
import logo1 from "./../../images/about/microsoft.webp";
import logo2 from "./../../images/about/amazon.webp";
import logo3 from "./../../images/about/ibm.webp";
import logo4 from "./../../images/about/informatica.webp";
import logo5 from "./../../images/about/pentaho.webp";
import logo6 from "./../../images/about/talend.webp";
import logo7 from "./../../images/about/teradata.webp";
import logo8 from "./../../images/about/cloudera.webp";
import logo9 from "./../../images/about/oracle.webp";
import logo10 from "./../../images/about/sap.webp";
import { Helmet } from "react-helmet";

const About = () => {
  const banner = {
    title: "About Us",
    image: Bannerimg,
  };
  return (
    <>
      <Helmet>
        <title>
          Our Story — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-6">
              <p>
                Cylon Technologies is an IT Consulting and IT Services company
                headquartered in Chicago, IL with offices across MI, Canada &
                India. Our Mission is to help customers achieve business
                objectives by providing best in class IT consulting and services
                with Digital, Strategy and technology consulting.
              </p>
              <p>
                Our practices include Application Development, Digital Strategy,
                Data and Analytics, Big Data and Data Science, Cloud Solutions,
                Business Intelligence & Data governance. Cylon Technologies has
                special focus & domain expertise in Healthcare, Financial
                Services, Retail, Insurance, Enegy& Utilities,
                Telecommunications.
              </p>
              <p>
                With our teams built around your domain and technology
                requirements, it helps Cylon and their customers develop
                strategic partnership that provides critically needed skills in
                business intelligence, analytics, application development,
                security and cloud transition by increasing strategic sourcing
              </p>
            </div>
            <div className="col-md-6">
              <p>
                Over past many years, Cylon Technologies has provided
                professional services to many clients across various locations
                utilizing Industry Standards and best practices.
              </p>
              <p>We are trusted by our clients. </p>
              <p>
                We are a team of Individuals that loves Challenges and your
                biggest challenge becomes our priority when we step in to work
                with you. We work with our clients closely forming one single
                team and achieve Success Together.
              </p>
              <h2 className="heading2">MISSION </h2>
              <p>
                Cylon Technologies Mission is to provide best in Class IT
                services to our customers, by showing our commitment through our
                decisions and actions.
              </p>
              <h2 className="heading2">VISION </h2>
              <p>
                To be the customers Trusted IT partners, through professional
                work Ethics, transparency and discipline.
              </p>
            </div>
          </div>

          <div className="row g-md-5 g-4">
            <div className="col-md-12">
              <div className="position-relative mt-5 black_fade">
                <img src={image2} />
                <div className="center_text">
                  <h2>We craft Fine Relationships</h2>
                  <p>Building Successful Relationships, Pioneering Success!</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-md-5 g-4">
            <div className="col-md-6">
              <h2 className="heading2">Our Alliances</h2>
              <p>
                Cylon Technologies partners with technology providers to offer
                the best tools and technologies, with a core objective to
                helping our customers leverage these for operational efficiency
                and better value out of technology investments. Our partnership
                with market leaders and niche players enable us to deliver a
                more comprehensive solution to our customers.
              </p>
              <p>
                The proliferation of disruptive technologies creates a constant
                challenge for organizations wishing to optimize existing assets
                and accommodate new technologies and often struggle to catch up.
                Organizations are constantly on the lookout for trusted advisers
                with the capabilities, knowledge and experience to help them
                navigate the new phase of globalization.
              </p>
            </div>
            <div className="col-md-6 ">
              <p className="mt-md-5">
                Working closely with some of these industry leading technology
                providers, complements and extends Cylon Technologies solutions
                and capabilities.
              </p>
              <p>
                Our relationships strengthen our ability to help clients
                achieve: Increased Operational Efficiency; Continuous Automation
                & Service Improvements; Consolidation and Optimization; and
                accelerated vendor identification and evaluation cycle time.
              </p>
            </div>
            <div className="col-md-6">
              <h2 className="heading2">Partners & Clients</h2>
              <h5>Our awesome clients are Awesome!</h5>
              <p>
                We take pride in calling our-self the Company with the best
                Customer Support & Client Satisfaction out there.
              </p>
              <p>
                We treat our clients like we do our friends and are always here
                to provide support, help & guidance.
              </p>
            </div>
          </div>
          <div className="row  g-4 logo_group">
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo1} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo2} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo3} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo4} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo5} alt="logo" />
            </div>

            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo6} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo7} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo8} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo9} alt="logo" />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src={logo10} alt="logo" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
